"use client";

var __jsx = React.createElement;
import { DEFAULT_LOCALE } from "@lib/constants";
import { getStoredLocale } from "@lib/util/locale-storage";
import SharedProviders from "@modules/providers/shared";
import getMessages from "messages/messages";
import React, { useEffect, useState } from "react";
const RootLayout = _ref => {
  let {
    children
  } = _ref;
  const {
    0: messages,
    1: setMessages
  } = useState(null);
  const {
    0: locale,
    1: setLocale
  } = useState(DEFAULT_LOCALE);
  useEffect(() => {
    const fetchMessages = async () => {
      if (typeof window !== "undefined") {
        const storedLocale = getStoredLocale();
        setLocale(storedLocale);
        const fetchedMessages = await getMessages(storedLocale);
        setMessages(fetchedMessages);
      }
    };
    fetchMessages();

    // Listen for locale changes from LocaleHandler component
    const handleLocaleChange = event => {
      const {
        locale: newLocale
      } = event.detail;
      if (newLocale && newLocale !== locale) {
        console.log("\uD83D\uDD04 Root layout updating messages for locale: ".concat(newLocale));
        setLocale(newLocale);
        // Refetch messages for the new locale
        getMessages(newLocale).then(newMessages => {
          setMessages(newMessages);
        });
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('localeChange', handleLocaleChange);
      return () => {
        window.removeEventListener('localeChange', handleLocaleChange);
      };
    }
  }, [locale]);
  if (!messages) {
    return __jsx("html", {
      lang: locale
    }, __jsx("body", null));
  }
  return __jsx("html", {
    lang: locale
  }, __jsx("head", null, __jsx("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }), process.env.NEXT_PUBLIC_GOOGLE_CONSOLE_VERIFICATION && __jsx("meta", {
    name: "google-site-verification",
    content: process.env.NEXT_PUBLIC_GOOGLE_CONSOLE_VERIFICATION
  })), __jsx("body", {
    style: {
      margin: 0
    }
  }, __jsx(SharedProviders, {
    locale: locale,
    messages: messages
  }, __jsx("div", null, __jsx("div", null, children)))));
};
export default RootLayout;